import { createActionBundle } from 'utilities/request';

export const {
  request: requestPatientsData,
  success: requestPatientsDataSuccess,
  failure: requestPatientsDataFailure,
} = createActionBundle('PATIENTS_DATA');

export const {
  fetch: patientUpdate,
  request: requestPatientUpdate,
  success: requestPatientUpdateSuccess,
  failure: requestPatientUpdateFailure,
} = createActionBundle('PATIENT/UPDATE');
